import { colors } from '../../../../../enums/colors';
import {currencyFormat} from "../../../../../Apis/functions";
import React from "react";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
export const MENU_MODEL = {
    id: null,
    dish: null,
    mealType: null,
    diner: null,
    foodieMealTimeIds: [],
    releaseDate: null,
    releaseHour: null,
    cafeteriaServingDate: null,
    courseType: null,
    departments: [],
    userIds: [],
    cost: null,
    isValidSetUp(showCostInfo) {//For create menu
        return (
            this.dish &&
            this.mealType &&
            this.diner &&
            (!showCostInfo || (showCostInfo && this.cost !== null && this.cost !== ''))
        );
    },

    isValidAvailability() {
        return (
            this.courseType?.toString().trim() &&
            this.releaseDate?.toString().trim() &&
            this.releaseHour != null &&
            this.cafeteriaServingDate?.toString().trim()
        );
    },
    isValid(showCostInfo) { // For update menu
        return (
            this.releaseDate &&
            this.releaseHour !== null &&
            this.releaseHour !== undefined &&
            this.cafeteriaServingDate &&
            (!showCostInfo || (showCostInfo && this.cost !== null && this.cost !== ''))
        );
    },
    toRegister: function () {
        return {
            id: this.id,
            foodieItemId: this.dish,
            foodieMealTypeId: this.mealType,
            foodieCafeteriaId: this.diner,
            cost: this.cost || 0,
            foodieMealTimeStocks: this.foodieMealTimeIds,
            releaseDate: this.releaseDate ? new Date(this.releaseDate).getTime() : null,
            releaseHour: this.releaseHour,
            servingDate: this.cafeteriaServingDate ? new Date(this.cafeteriaServingDate).getTime() : null,
            foodieCourseTypeId: this.courseType,
            departments: this.departments,
            userIds: this.userIds,
        };
    },
    set: function (data) {
        return {
            ...this,
            id: data.id,
            dish: data.foodieItemId,
            mealType: data.foodieMealTypeId,
            diner: data.foodieCafeteriaId,
            cost: data.cost,
            foodieMealTimeIds:
                data.mealTimes?.map((m) => ({
                    id: m.id,
                    label: m.name,
                })) || [],
            releaseDate: data.releaseDate,
            releaseHour: data.releaseHour,
            cafeteriaServingDate: data.servingDate,
            courseType: data.foodieCourseTypeId,
            departments:
                data.departments?.map((d) => ({
                    id: d.departmentId,
                    label: d.departmentName,
                    subtitle: 'available_after',
                    unit: d.availableAfterMinutes,
                })) || [],

            userIds:
                data.users?.map((d) => ({
                    id: d.id,
                    label: d.name,
                })) || [],
        };
    },
    setToClone: function (data) {
        return {
            ...this,
            id: null,
            dish: data.foodieItemId,
            mealType: data.foodieMealTypeId,
            diner: data.foodieCafeteriaId,
            cost: data.cost,
            foodieMealTimeIds:
                data.mealTimes?.map((m) => ({
                    id: m.id,
                    label: m.name,
                    subtitle: 'units',
                    unit: m.mealStock,
                })) || [],
            releaseDate: null,
            releaseHour: null,
            cafeteriaServingDate: null,
            courseType: data.foodieCourseTypeId,
            departments:
                data.departments?.map((d) => ({
                    id: d.departmentId,
                    label: d.departmentName,
                    subtitle: 'available_after',
                    unit: d.availableAfterMinutes,
                })) || [],

            userIds:
                data.users?.map((d) => ({
                    id: d.id,
                    label: d.name,
                })) || [],
        };
    },
};

export const AVAILABILITY_MODEL = {
    AVAILABLE: 'AVAILABLE',
    UNAVAILABLE: 'UNAVAILABLE',
};

export const availabilityStatusStyles = {
    [AVAILABILITY_MODEL.AVAILABLE]: {
        background: colors.success100,
        fontColor: colors.success700,
        borderColor: colors.success150,
    },
    [AVAILABILITY_MODEL.UNAVAILABLE]: {
        background: colors.errorCode100,
        fontColor: colors.errorCode700,
        borderColor: colors.errorCode150,
    },
};

export const MealTypeEnum = {
    1: { name: 'basic' },
    2: { name: 'normal' },
    3: { name: 'premium' },
    4: { name: 'special_occasion' },
};

export const MealType = {
    1: "basic",
    2: "normal",
    3: "premium",
    4: "special_occasion"
};

export const MealTypeEnumModel = {
    basic: { trans: 'basic', name: 'Basic', id: 1 },
    normal: { trans: 'normal', name: 'Normal', id: 2 },
    premium: { trans: 'premium', name: 'Premium', id: 3 },
    specialOccasion: { trans: 'special_occasion', name: 'Special Occasion', id: 4 },
};

export const DishCategoryEnum = {
    1: { name: 'starter' },
    2: { name: 'main_course' },
    3: { name: 'side_course' },
    4: { name: 'dessert' },
};

export const DishCategoryPayload = {
    1: "starter",
    2: "main",
    3: "side",
    4: "dessert"
};

export const COURSE_TYPE_MODEL = {
    STARTER:"starter",
    MAIN_COURSE:"main_course",
    SIDE_COURSE:"side_course",
    DESSERT:"dessert"
};


export const MEAL_FORECAST_EXPORT_HEADERS = ["name", "total"];

export const MEAL_FORECAST_MODEL = {
    cafeteriaId: null,
    start:  null,
    end: null,
    toRegister: function () {
        let start = this.start ? new Date(this.start): new Date();
        let end = this.end ? new Date(this.end): new Date();

        if(!this.start){
            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);
        }

        return {
            cafeteriaId: this?.cafeteriaId,
            since: start.getTime(),
            to: end.getTime()
        }
    },
};

export const TO_CLONE_ARRAYS = {
    MEALTIMES: 'foodieMealTimeIds',
    USERS: 'userIds',
    DEPARTMENTS: 'departments',
};
export const DEPARTMENT_MODEL = {
    item: null,
    unit: '',

    validate({ selectedDepartment, setNotSelected, setNotAdded }) {
        const { item, unit } = this;

        const oneFilledAndOneEmpty = (item && !unit) || (unit && !item);
        const notAddedYet = item && unit && selectedDepartment.length === 0;
        const showToast = item && unit;
        const isEmpty = oneFilledAndOneEmpty || notAddedYet;

        if (setNotSelected && setNotAdded) {
            if (oneFilledAndOneEmpty) {
                setNotSelected(true);
                setNotAdded(false);
            } else if (notAddedYet) {
                setNotAdded(true);
                setNotSelected(false);
            } else {
                setNotSelected(false);
                setNotAdded(false);
            }
        }
        return {
            oneFilledAndOneEmpty,
            notAddedYet,
            showToast,
            isEmpty,
        };
    },
};
export const MEAL_TIME_MODEL = {
    item: null,
    unit: '',

    validate({ selectedMealTime, setNotSelected, setNotAdded }) {
        const { item, unit } = this;
        const isRequiredEmpty = selectedMealTime.length === 0 && !item && !unit;

        if (isRequiredEmpty) {
            setNotSelected?.(true);
            setNotAdded?.(false);
            return { isEmpty: true };
        }
        const oneFilledAndOneEmpty = (item && !unit) || (unit && !item);
        const notAddedYet = item && unit && selectedMealTime.length === 0;
        const showToast = item && unit;
        const isEmpty = oneFilledAndOneEmpty || notAddedYet;

        if (setNotSelected && setNotAdded) {
            if (oneFilledAndOneEmpty) {
                setNotSelected(true);
                setNotAdded(false);
            } else if (notAddedYet) {
                setNotAdded(true);
                setNotSelected(false);
            } else {
                setNotSelected(false);
                setNotAdded(false);
            }
        }
        return {
            oneFilledAndOneEmpty,
            notAddedYet,
            showToast,
            isEmpty,
        };
    },
    updateState({ selectedMealTime, setEmptyMealTime, setMealTime, setUpdate, toast, t }) {
        const { oneFilledAndOneEmpty, showToast } = this.validate({
            selectedMealTime,
            setNotSelected: () => {},
            setNotAdded: () => {},
        });

        const bothEmpty = !this.item && !this.unit;

        if (bothEmpty) {
            setEmptyMealTime(false);
        } else if (oneFilledAndOneEmpty) {
            setEmptyMealTime(true);
        } else {
            setEmptyMealTime(false);
        }

        if (showToast) {
            toast.warn(t('click_to_add'));
        }

        if (selectedMealTime.length > 0) {
            setMealTime({ ...MEAL_TIME_MODEL });
        }

        setUpdate(false);
    },
};

/**
 * Renders a formatted cost value inside a styled paragraph element.
 *
 * If the cost is null or undefined, it defaults to 0.
 * The value is formatted as currency using `currencyFormat`.
 *
 * @param {number|null|undefined} cost - The cost value to display.
 * @returns {JSX.Element} A paragraph element with the formatted cost.
 */
export const renderCost = (cost) =>{
    return  <p className={"font-color-error-600 ibl-font-w-400 fs-14px"}>
        {cost != null
            ? `${'$ ' + currencyFormat(cost)}`
            : `${'$ ' + currencyFormat(0)}`}
    </p>
}
